import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("rect", {
  x: "18.7175",
  y: "19.4258",
  width: "20",
  height: "1",
  transform: "rotate(-135 18.7175 19.4258)",
  fill: "currenColor"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "4.57544",
  y: "18.7188",
  width: "20",
  height: "1",
  transform: "rotate(-45 4.57544 18.7188)",
  fill: "#currenColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { iconAttributes } from '@/utils/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'Delete',
  setup(__props) {

const attrs = iconAttributes({ width: 24, height: 24 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _hoisted_3, 16))
}
}

})